;(function cartModalLoader() {
    function cartModalLoader() {
        /**
         * @private
         */
        var _this = this

        /**
         * template Service
         * @property templateService
         * @type {function}
         */
        this.templateService = new window.Creaton.templateService()

        /**
         * global cart configuration
         * @type {Object}
         */
        this.config = {}

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.config = window.Creaton.Cart.Configuration
            _this.bind()
        }

        /**
         * bind cart cta button and modal cleanup if becomes closed
         * @returns {undefined}
         */
        this.bind = function () {
            _this.config.$cartModalCta.bind('click', function () {
                _this.updateModal(this)
            })

            _this.config.$cartModal.on('hidden.bs.modal', function (e) {
                _this.config.$modalBody.html('')
            })
        }

        /**
         * fill the modal
         * @returns {undefined}
         */
        this.updateModal = function (product) {
            // We need to check if we´re currently on the product or catalog page.
            if ($(product).closest('.js-product-catalog-card-link')[0]) {
                // Catalog page
                var link = $(product).closest('.js-product-catalog-card-link')[0].getAttribute("href");
            } else {
                // Product page
                var link = window.location.pathname;
            }
            var colors = $(product).data('colors')
            var title = $(product).data('product-title')
            var category = $(product).data('product-category')
            var country = $(product).data('product-country')
            _this.config.$modalHeader.html(title)
            $.each(colors, function (index, color) {
                _this.fillTemplate(color, title, category, country, link)
            })
        }

        /**
         * fill a html script template
         * is defined at Creaton.Product/Resources/Private/Fusion/Component/CartModal.fusion
         * @param color
         * @param title
         * @param category
         * @param country
         * @param link
         * @return {undefined}
         */
        this.fillTemplate = function (color, title, category, country, link) {
            var templateContent = {
                '###title###': color['title'],
                '###orderCode###': color['orderCode'],
                '###link###': link,
                '###imageUri###': color['imageUri'],
                '###productTitle###': title,
                '###statusClass###': '',
                '###productCategory###': category,
                '###productCountryCode###': country,
                '###colorIdentifier###': color['colorIdentifier'],
                '###available###': color['available']
            }

            if (!color['available']){
                templateContent['###statusClass###'] = 'not-available'
            } else if (_this.config.cartItems.hasOwnProperty(color['orderCode'])) {
                templateContent['###statusClass###'] = 'active'
            }

            _this.config.$modalBody.append(
                _this.templateService.getFilledTemplate(_this.config.templateContainer, templateContent)
            )
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }
    window.Creaton.cartModalLoader = cartModalLoader
})()
